@if (operation) {
    <tec-collapse
        [icon]="'icon-fill-form'"
        [title]="'PROCESSES.DETAIL.FORM' | translate"
        [tags]="[
            {
                label: ('MASTER.STATUS.' + displayState | translate),
                status: masterService.getTagStatus(displayState)
            }
        ]"
        [expanded]="expanded"
        (clickEvent)="toggleCollapse?.emit($event)"
    >
        <app-developer-curl-button
            ngProjectAs="tec-button-icon"
            [path]="operationCurlPath"
            titleKey="PROCESSES.CURL_MODAL.TITLE_OPERATION"
        />
        @if (loading && !contentReady) {
            <tec-tile [type]="'loading'" [title]="'LOADING.PROCESS_DETAIL' | translate" />
        } @else if (operation.state !== OPERATION_STATUS.INIT && operation.state !== OPERATION_STATUS.NOT_STARTED) {
            <tec-tile [title]="'PROCESSES.DETAIL.DETAILS' | translate">
                @if (dataSections.length) {
                    <app-form-operation-detail-sections
                        [sections]="dataSections"
                    />
                } @else {
                    <tec-empty-state
                        [title]="'PROCESSES.DETAIL.FORM_NO_RESPONSES' | translate"
                        [size]="'default'"
                        [type]="'empty'"
                    />
                }
            </tec-tile>

            <tec-tile [title]="'PROCESSES.DETAIL.OPERATION' | translate">
                <app-operation-detail-operation-meta
                    variant="process"
                    [operationUuid]="operation.uuid"
                    [startAt]="operation.start_at"
                    [endAt]="operation.end_at"
                    [totalTime]="operation.total_time"
                    triesStyle="badge"
                    [triesLabel]="formTriesLabel()"
                    [state]="displayState"
                    [showKoOnTries]="true"
                />
            </tec-tile>

            @if (operation.uuid) {
                <tec-button
                    [label]="'PROCESSES.DETAIL.SEE_OPERATION' | translate"
                    (clickEvent)="goToOperationDetail(operation.uuid, $event)"
                />
            }
        } @else {
            <tec-empty-state
                [title]="'GENERAL.NO_DATA' | translate"
                [size]="'default'"
                [type]="'empty'"
            />
        }
    </tec-collapse>
}
